import { AppBar, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from 'src/assets/svgs/logo.svg';
import { PatientSearchBar } from 'src/components/PatientSearchBar';
import { DashboardLayoutHeaderMenu } from './DashboardLayoutHeaderMenu';
import {
  dashboardLayoutHeaderContentStyles,
  dashboardLayoutHeaderLeft,
  dashboardLayoutHeaderRight,
  dashboardLayoutHeaderStyles,
  logoContainerStyles,
} from './styles';

export function DashboardLayoutHeader(): React.JSX.Element {

  

  return (
    <AppBar sx={dashboardLayoutHeaderStyles}>
      <Box sx={dashboardLayoutHeaderContentStyles}>
        <Box sx={dashboardLayoutHeaderLeft}>
          <Box sx={logoContainerStyles}>
            <Link to="/">
              <Logo title="logo" />
            </Link>
          </Box>
        </Box>
        <Box sx={dashboardLayoutHeaderRight}>
          <PatientSearchBar />
          <DashboardLayoutHeaderMenu />
        </Box>
      </Box>
    </AppBar>
  );
}
